import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { coverByOffersStates } from 'contexts/OfferPage/offerPageStateReducer'
import { useAppSelector } from 'hooks/reduxHooks'
import { isBundleOffer } from 'lib/offer/offerTypes'
import { useContext } from 'react'

import { isAvailableForPurchase } from 'selectors/offerPage/offerPageSelectors'

/**
 * @deprecated
 * Don't use this, use the appropriate selector
 * There is no way to effeciently prevent extra renders with the hook implementation
 * due to using offer page state context directly
 */
function useIsAvailableForPurchase(providedOfferState?: OfferPageState) {
  const offerPageState = useContext(OfferPageStateContext)
  // prefer the provided state over the one from context
  // this is mostly used for when being called at the same level as the context is set
  // so the context isn't available yet
  const offerState = providedOfferState ?? offerPageState
  const bundleOffer = isBundleOffer(offerState?.offer)
  const available = useAppSelector((state) => {
    if (!bundleOffer) {
      return isAvailableForPurchase(offerState, state)
    }
    return false
  })
  const bundleAvailable = useAppSelector(state => {
    if (bundleOffer) {
      return coverByOffersStates(isAvailableForPurchase, offerState, state).every(available => !!available)
    }
    return false
  })

  return bundleOffer ? bundleAvailable : available
}

export default useIsAvailableForPurchase
